import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import { signOut } from "firebase/auth";
import { auth } from "./config/firebase";

class AppErrorBoundary extends React.Component {
  constructor(props) { super(props); this.state = { error: null }; }
  static getDerivedStateFromError(error) { return { error }; }
  componentDidCatch(error, info) { console.error("AWC School render error", error, info); }
  render() {
    if (!this.state.error) return this.props.children;
    return <div style={{minHeight:"100vh",background:"#0a1128",color:"#f8fafc",display:"grid",placeItems:"center",padding:"24px",fontFamily:"system-ui"}}>
      <div style={{maxWidth:480,width:"100%",background:"#111827",border:"1px solid #334155",borderRadius:24,padding:32,textAlign:"center"}}>
        <img src="/logo.png" alt="AWC School" style={{width:112,height:112,objectFit:"contain"}}/>
        <h1 style={{fontSize:24,margin:"12px 0"}}>Workspace could not load</h1>
        <p style={{color:"#94a3b8",fontSize:14,lineHeight:1.6}}>Your session is safe. Reload the workspace to recover. If the problem continues, sign out and sign in again.</p>
        <button onClick={()=>window.location.reload()} style={{width:"100%",marginTop:20,padding:13,border:0,borderRadius:12,background:"#f59e0b",fontWeight:800,cursor:"pointer"}}>Reload workspace</button>
        <button onClick={async()=>{try{await signOut(auth)}finally{sessionStorage.clear();window.location.assign("/")}}} style={{width:"100%",marginTop:10,padding:12,border:"1px solid #475569",borderRadius:12,background:"transparent",color:"#cbd5e1",fontWeight:700,cursor:"pointer"}}>Sign out safely</button>
        <details style={{marginTop:18,textAlign:"left",color:"#64748b",fontSize:11}}><summary>Technical details</summary><pre style={{whiteSpace:"pre-wrap"}}>{String(this.state.error?.message || this.state.error)}</pre></details>
      </div>
    </div>;
  }
}

createRoot(document.getElementById("root")).render(
  <React.StrictMode><AppErrorBoundary><App /></AppErrorBoundary></React.StrictMode>
);
